import { Box, Picture } from "@jewlr/storybook/core"
import PropTypes from "prop-types"

const MainBanner = ({ src, alt }) => (
  <Box mb={{ _: 3, tablet: 6 }} width="100%">
    <Picture
      alt={alt}
      fallback={`${sl.config.jewlr_asset_url}images/info/jewlr/main_banners/${src}/desktop_2x.jpg`}
      srcSet={[
        {
          height: "228",
          media: "(max-width: 767px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/jewlr/main_banners/${src}/mobile.jpg 767w`,
          width: "767",
        },
        {
          height: "285",
          media: "(min-width: 768px) and (max-width: 1023px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/jewlr/main_banners/${src}/tablet.jpg 1005w`,
          width: "1005",
        },
        {
          height: "285",
          media: "(min-width: 1024px)",
          sizes: "100vw",
          srcSet: `${sl.config.jewlr_asset_url}images/info/jewlr/main_banners/${src}/desktop.jpg 1920w, ${sl.config.jewlr_asset_url}images/info/jewlr/main_banners/${src}/desktop_2x.jpg 3840w`,
          width: "1920",
        },
      ]}
      width="100%"
    />
  </Box>
)

MainBanner.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
}

export default MainBanner
